import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Icon, Button } from 'shared/components';

import UserDetailsForm from '../../_forms/UserDetailsForm';
import theme from './EditUserModal.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  isSubmittingForm: PropTypes.bool,
  userTitleOptions: PropTypes.array,
  userGenderOptions: PropTypes.array,
  userTypeOptions: PropTypes.array,
  submitForm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
  setRef: PropTypes.func.isRequired,
  handleScrollToFirstError: PropTypes.func.isRequired,
  handleCancelClick: PropTypes.func.isRequired,
};

const defaultProps = {
  isSubmittingForm: false,
  userTitleOptions: [],
  userGenderOptions: [],
  userTypeOptions: [],
};

const EditUserModal = ({
  intl,
  onCancel,
  submitForm,
  isSubmittingForm,
  submitAction,
  setRef,
  handleScrollToFirstError,
  handleCancelClick,
  ...formProps
}) => (
  <div className={ theme.container }>

    <div className={ theme.header }>
      <h2 tabIndex={ 0 }>
        { intl.formatMessage({ id: 'MyAccount.Details.Edit.Title', defaultMessage: '** Edit user details' })}
      </h2>
      <button onClick={ handleCancelClick } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.body } ref={ setRef }>
      <UserDetailsForm
        { ...formProps }
        onSubmit={ submitForm }
        onSubmitFail={ handleScrollToFirstError }
        userEmailDisabled={ false }
        userTypeDisabled={ true }
      />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="edit-cancel-button"
        label={ intl.formatMessage({ id: 'MyAccount.Details.Edit.Cancel', defaultMessage: '** Cancel' }) }
        className={ theme.cancelButton }
        buttonType="naked"
        labelColor="blackMedium"
        disabled={ isSubmittingForm }
        onClick={ handleCancelClick }
      />

      <Button
        testId="edit-save-button"
        label={ intl.formatMessage({ id: 'MyAccount.Details.Edit.Save', defaultMessage: '** Save' }) }
        className={ theme.saveButton }
        iconName="check"
        iconPositionLeft
        isLoading={ isSubmittingForm }
        background="primary"
        disabled={ isSubmittingForm }
        onClick={ submitAction }
        iconDontFlipOnRtl
      />
    </div>
  </div>
);

EditUserModal.propTypes = propTypes;
EditUserModal.defaultProps = defaultProps;

export default EditUserModal;
